import axios from 'axios'

import { getAuthApiUrl } from '@/helpers/helpers'
import { type AuthCredentials, toAuthRoleCookie } from '@/utils/auth'

type ImpersonatedUserData = {
  buildingId: unknown
  user: { role: string }
}

/**
 * Same current-user lookup as `API.getUserData`, but with the impersonated token passed explicitly
 * instead of read from the cookie. That lets the new session be verified before it is swapped in,
 * so the rest of the app never sends requests with a token that might be rejected. Bare axios on
 * purpose: `authAPI` would overwrite the header with the cookie token, and its 401 handler would
 * end the support user's own session.
 */
export const getImpersonatedUser = async ({ token, role }: AuthCredentials) => {
  const response = await axios.get<ImpersonatedUserData>(
    `${getAuthApiUrl()}/${toAuthRoleCookie(role).toLowerCase()}`,
    { headers: { 'Content-Type': 'application/json', token } },
  )
  return response.data
}
